var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoop = function SvgLoop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.747 16.967a9.266 9.266 0 0 1 2.666-7.56A9.305 9.305 0 0 1 20.2 7.673 1.33 1.33 0 0 0 21.4 5.3 11.956 11.956 0 0 0 7.52 7.527 11.953 11.953 0 0 0 4.253 18.34l2.494-1.373ZM27.734 13.647l-2.48 1.373a9.266 9.266 0 0 1-2.667 7.56A9.305 9.305 0 0 1 11.8 24.313a1.33 1.33 0 0 0-1.2 2.373A12.005 12.005 0 0 0 16 27.98c3.107 0 6.16-1.213 8.467-3.52a11.953 11.953 0 0 0 3.267-10.813Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m23.82 16.15 5.461-2.214c.85-.345.81-1.064.048-1.54L25.23 9.788c-.617-.396-1.226-.149-1.403.57l-1.11 4.732c-.215.873.275 1.396 1.102 1.06ZM8.09 15.97l-5.462 2.214c-.849.344-.81 1.064-.047 1.54l4.098 2.608c.617.396 1.226.149 1.404-.57l1.109-4.732c.216-.873-.275-1.396-1.102-1.06Z",
    fill: "currentColor"
  })));
};
export default SvgLoop;